import React from 'react';
import { Grid } from '@mui/material';
import { StatusCard } from '../../common/components';
import { buildStatusCard, type MedNecStatus } from '../utils/statusConfig';

interface WorkflowDashboardGridProps {
  statusCounts: Record<string, number>;
  onStatusClick: (status: MedNecStatus) => void;
}

// ── Row 1: Main workflow path ──────────────────────────────────────
const ROW_1: MedNecStatus[] = [
  'Pending',
  'Under Review',
  'Submitted',
  'Payer Approved',
];

// ── Row 2: Physician Response and Payer outcomes ───────────────────
const ROW_2: (MedNecStatus | null)[] = [
  'Awaiting Physician Response',
  'Payer Denied',
];

/**
 * MedNec dashboard — responsive grid of clickable status cards.
 * Row 1: Pending → Under Review → Submitted → Payer Approved
 * Row 2: Physician Query   Denied
 */
const WorkflowDashboardGrid: React.FC<WorkflowDashboardGridProps> = ({ statusCounts, onStatusClick }) => {
  const count = (s: MedNecStatus) => statusCounts[s] || 0;

  return (
    <Grid
      container
      spacing={2}
      rowSpacing={{ xs: 4, sm: 5, md: 6 }}
      sx={{ px: 0 }}
    >
      {/* ── Row 1 ────────────────────────────────────────────────── */}
      {ROW_1.map((status) => {
        const card = buildStatusCard(status, count(status));
        return (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={status}>
            <StatusCard {...card} onClick={() => onStatusClick(status)} />
          </Grid>
        );
      })}

      {/* ── Row 2 ────────────────────────────────────────────────── */}
      {ROW_2.map((status, idx) => {
        if (status === null) {
          return <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={`spacer-${idx}`} />;
        }
        const card = buildStatusCard(status, count(status));
        return (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={status}>
            <StatusCard {...card} onClick={() => onStatusClick(status)} />
          </Grid>
        );
      })}

    </Grid>
  );
};

export default WorkflowDashboardGrid;
